module.exports = __webpack_public_path__ + "r-v3/img/heart_empty.46b0d1d3.svg";